// src/pages/QuotationRecord/QuotationRecordThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../apiservice/apis";
import { apiQuotationDeleteApi } from "../../apiservice/quotation";

export const fetchQuotationRecord = createAsyncThunk(
  "quotationRecord/fetch",
  async ({ selectedFilterType, selectedRecordType, filters }, { rejectWithValue }) => {
    try {
      let url = "/sales/get-sales-quotation-record"; // default

      if (selectedRecordType === "with item") {
        url = "/sales/get-sales-quotation-record-with-details";
      }
      if (
        ["By Item", "By Tag", "By Group", "By Category"].includes(selectedFilterType)
      ) {
        url = "/quotation/get-sales-quotaion-details";
      }

      const payload = {
        selectedFilterType: selectedFilterType || null,
        selectedRecordType: selectedRecordType || null,
        locationId: filters.locationId || null,
        customerId: filters.customerId || null,
        // employeeId: filters.employeeId || null,
        itemId: filters.itemId || null,
        groupId: filters.groupId || null,
        categoryId: filters.categoryId || null,
        userId: filters.userId || null,
        tag_groupnameid: filters.tag_groupnameid || null,
        tagFeildNameid: filters.tagFeildNameid || null,
        fromDate: filters.fromDate || null,
        toDate: filters.toDate || null,
      };

      const res = await postData(url, payload);
      
      let mapped = [];
      if (selectedRecordType === "with item") {
        // detailed rows
        mapped = res.data.flatMap((q, qIdx) =>
          
          
            (q.details || []).map((item, idx) => ({
            id: `${q.sale_o_id}-${item.item_id}-${idx}`,
            q_id: q.sale_o_id,
            vch_no: q.sale_order_no,
            date: q.created_date,
            customer: q.acc_name,
            // employee: q.employee_name,
            createdBy: q.full_name,
            mode: q.trans?.map((t) => t.to_acc_name).join(", ") || "",
            item: item.item_name,
            rate: Number(item.item_rate || 0),
            discount: Number(item.item_discount_per || 0),
            vat: Number(item.item_tax_per || 0),
            qty: Number(item.qty || 0),
            total: Number(item.item_total || 0),
            unitDetails: `Master U. Qty = ${item.item_qty || 0}, Base U. Qty = ${item.retail_qty || 0}`,
          }))
        );
      } else {
        // summary rows
        mapped = res.data.map((row) => ({
          id: row.sale_o_id,
          q_id: row.sale_o_id,
          vch_no: row.sale_order_no,
          date: row.created_date,
          customer: row.acc_name,
          employee: row.employee_name,
          createdBy: row.full_name,
          mode: row.trans?.map((t) => t.to_acc_name).join(", ") || "",
          subtotal: Number(row.sub_total || 0),
          discount: Number(row.total_discount || 0),
          vat: Number(row.total_tax || 0),
          service: Number(row.other_service_cost || 0),
          total: Number(row.total_amount || 0),
          paid: Number(row?.paid_total || 0),
          due: Number(row?.due_total || 0),
          items: row.details || [],
        }));
      }

      return mapped;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const deleteQuotationRecord = createAsyncThunk(
  "quotationRecord/delete",
  async (id, { rejectWithValue }) => {
  try {
      const res = await apiQuotationDeleteApi({ sale_o_id:id });
      return { id, message: res.data?.message || "Deleted successfully" };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchQuotationWithDetails = createAsyncThunk(
  "quotationRecord/fetchQuotationWithDetails",
  async (id, { rejectWithValue }) => {
    try {
      const res = await postData("/sales/get-sales-quotation-record-with-details", {
        sale_o_id: id, // adjust param if backend expects 'quotation_id' or similar
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

